<template>
  <b-modal
    :id="modalId"
    size="xl"
    scrollable
    no-close-on-backdrop
    modal-class="db-modal"
    @show="showModal"
    @hidden="hiddenModal"
  >
    <template #modal-header>
      <div class="db-modal-head">
        <h2 class="db-modal-title">{{ noticia ? "Editar noticia" : "Nueva noticia" }}</h2>
        <p class="db-modal-subtitle">
          {{ esCaritas ? "Cáritas parroquial" : "Noticias de la parroquia" }}
          <template v-if="noticia"> · creada el {{ formatFecha(noticia.fechaDePublicacion) }}</template>
        </p>
      </div>
      <button type="button" class="db-icon-btn" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <div class="en-layout">
      <!-- Columna principal -->
      <div class="db-form">
        <div class="db-field">
          <label class="db-label" for="en-titulo">Título</label>
          <input
            id="en-titulo"
            v-model="tituloNoticia"
            type="text"
            class="db-input en-titulo"
            :class="{ 'is-invalid': intentado && !tituloNoticia }"
            placeholder="Escribe el título de la noticia"
          />
        </div>

        <div class="db-field">
          <label class="db-label" for="en-resumen">
            Resumen
            <span class="db-hint">{{ (resumenNoticia || "").length }} / {{ MAX_RESUMEN }}</span>
          </label>
          <textarea
            id="en-resumen"
            v-model="resumenNoticia"
            class="db-input"
            :class="{ 'is-invalid': intentado && !resumenNoticia }"
            :maxlength="MAX_RESUMEN"
            rows="3"
            placeholder="Un par de frases que aparecerán en la tarjeta de la noticia…"
          ></textarea>
        </div>

        <div class="db-field">
          <span class="db-label">Contenido</span>
          <editor-de-texto
            :htmlForEditor="htmlForEditor"
            :obtenerCambiosHtml="obtenerCambiosHtml"
            @nuevoHtml="nuevoHtml"
          />
        </div>
      </div>

      <!-- Columna lateral -->
      <aside class="en-side">
        <section class="en-box">
          <h3 class="en-box-title">Publicación</h3>
          <label class="db-switch">
            <input v-model="estadoNoticia" type="checkbox" />
            <span class="db-switch-track"></span>
            {{ estadoNoticia ? "Publicada" : "Borrador (no visible)" }}
          </label>
          <label v-if="esCaritas" class="db-switch">
            <input v-model="paginaPrincipal" type="checkbox" />
            <span class="db-switch-track"></span>
            Mostrar en la portada
          </label>
          <label v-if="estadoNoticia" class="db-switch" title="Envía una notificación a quien tiene activados los avisos en la web">
            <input v-model="avisarMovil" type="checkbox" />
            <span class="db-switch-track"></span>
            Avisar en el móvil al guardar
          </label>
          <div class="db-field">
            <label class="db-label" for="en-fecha">Fecha de publicación</label>
            <input id="en-fecha" v-model="fechaNoticia" type="date" class="db-input" />
          </div>
        </section>

        <section class="en-box">
          <h3 class="en-box-title">Imagen de portada</h3>
          <button
            type="button"
            class="db-image-pick"
            :class="{ 'has-image': imagePortada, 'is-invalid': intentado && !imagePortada }"
            @click="$bvModal.show(idSelectorPortada)"
          >
            <template v-if="imagePortada">
              <img v-img-fallback :src="`${base}/img/minGallery/${imagePortada}`" alt="Portada seleccionada" />
              <span class="db-image-pick-overlay">
                <span class="material-symbols-outlined">swap_horiz</span> Cambiar
              </span>
            </template>
            <span v-else class="db-image-pick-empty">
              <span class="material-symbols-outlined">add_photo_alternate</span>
              Elegir imagen
            </span>
          </button>
          <button v-if="imagePortada" type="button" class="db-btn db-btn--ghost db-btn--sm" @click="imagePortada = undefined">
            Quitar portada
          </button>
        </section>

        <section class="en-box">
          <h3 class="en-box-title">Galería vinculada</h3>
          <select v-model="gallerySelected" class="db-input" aria-label="Galería vinculada">
            <option :value="0">Sin galería</option>
            <option v-for="g in galleryOptions" :key="g.value" :value="g.value">{{ g.text }}</option>
          </select>
          <p class="db-hint">Se mostrará un botón "Ver galería completa" en la noticia.</p>
        </section>

        <section class="en-box">
          <h3 class="en-box-title">
            Fotos de la noticia
            <span class="db-badge">{{ imagenesnoticiaSeleccionada.length }}</span>
          </h3>
          <div v-if="imagenesnoticiaSeleccionada.length" class="en-thumbs">
            <img v-img-fallback
              v-for="img in imagenesnoticiaSeleccionada.slice(0, 8)"
              :key="img"
              :src="`${base}/img/minGallery/${img}`"
              alt=""
              loading="lazy"
            />
            <span v-if="imagenesnoticiaSeleccionada.length > 8" class="en-thumbs-more">
              +{{ imagenesnoticiaSeleccionada.length - 8 }}
            </span>
          </div>
          <button type="button" class="db-btn db-btn--ghost db-btn--sm" @click="$bvModal.show(idSelectorImagenes)">
            <span class="material-symbols-outlined">photo_library</span>
            {{ imagenesnoticiaSeleccionada.length ? "Cambiar fotos" : "Añadir fotos" }}
          </button>
        </section>
      </aside>
    </div>

    <selectorImagenes :id="idSelectorPortada" @imagen="remplaceImagePortada" />
    <selectorImagenes
      :id="idSelectorImagenes"
      :dataGallery="imagenesnoticiaSeleccionada"
      :multiSelect="true"
      @imagen="imagenesNoticia"
    />

    <template #modal-footer>
      <p v-if="intentado && faltan.length" class="en-error">
        <span class="material-symbols-outlined">error</span> Falta: {{ faltan.join(", ") }}.
      </p>
      <span class="db-toolbar-spacer"></span>
      <button type="button" class="db-btn db-btn--ghost" @click="closeModal">Cancelar</button>
      <button type="button" class="db-btn" :disabled="guardando" @click="saveNews">
        <span v-if="guardando" class="db-spinner"></span>
        <span v-else class="material-symbols-outlined">save</span>
        {{ noticia ? "Guardar cambios" : "Crear noticia" }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import editorDeTexto from "./EditorDeTexto.vue";
import axios from "@/directives/axios.js";
import selectorImagenes from "./SelectorImages.vue";
import {
  avisar,
  formatFecha,
  parseFecha,
  toISODate,
  avisarError,
} from "@/directives/dbDialogs.js";

export default {
  name: "editorDeNoticias",

  components: {
    editorDeTexto,
    selectorImagenes,
  },
  props: ["modalId", "galerias", "noticia"],
  data() {
    return {
      estadoNoticia: false,
      obtenerCambiosHtml: true,
      gallerySelected: 0,
      fechaNoticia: toISODate(new Date()),
      tituloNoticia: "",
      imagePortada: undefined,
      resumenNoticia: "",
      htmlForEditor: "<p></p>",
      imagenesnoticia: undefined,
      paginaPrincipal: false,
      avisarMovil: false,
      guardando: false,
      intentado: false,
      base: this.$media,
    };
  },
  computed: {
    MAX_RESUMEN: () => 1000,
    // Campos obligatorios según la API (titulo, resumenNoticia e imagenPortada)
    faltan() {
      const f = [];
      if (!this.tituloNoticia) f.push("título");
      if (!(this.resumenNoticia || "").trim()) f.push("resumen");
      if (!this.imagePortada) f.push("imagen de portada");
      return f;
    },
    esCaritas() {
      return this.modalId === "editorDeNoticiasCaritas";
    },
    idSelectorPortada() {
      return this.modalId + "-portada";
    },
    idSelectorImagenes() {
      return this.modalId + "-imagenes";
    },
    imagenesnoticiaSeleccionada() {
      return this.imagenesnoticia ? this.imagenesnoticia : [];
    },
    galleryOptions() {
      return (this.galerias || []).map((g) => ({ value: g.id, text: g.titulo }));
    },
  },
  methods: {
    formatFecha,
    hiddenModal() {
      this.obtenerCambiosHtml = true;
      this.gallerySelected = 0;
      this.fechaNoticia = toISODate(new Date());
      this.tituloNoticia = "";
      this.imagePortada = undefined;
      this.resumenNoticia = "";
      this.htmlForEditor = "<p></p>";
      this.imagenesnoticia = undefined;
      this.paginaPrincipal = false;
      this.avisarMovil = false;
      this.estadoNoticia = false;
      this.guardando = false;
      this.intentado = false;
    },
    showModal() {
      this.$store.dispatch("changeAllImages");
      if (this.noticia) {
        this.estadoNoticia = this.noticia.estadoNoticia == 1;
        this.resumenNoticia = this.noticia.noticia || "";
        this.tituloNoticia = this.noticia.titulo || "";
        this.imagenesnoticia = this.noticia.imagenesNoticia;
        this.paginaPrincipal = this.noticia.paginaPrincipal == 1;
        this.fechaNoticia = toISODate(parseFecha(this.noticia.fechaDePublicacion)) || toISODate(new Date());
        this.gallerySelected = this.noticia.galeria && this.noticia.galeria != 0 ? this.noticia.galeria : 0;
        this.htmlForEditor = this.noticia.resumenNoticia || "<p></p>";
        this.imagePortada = this.noticia.imagenDePortada;
      }
    },
    // El editor devuelve el HTML cuando se le pide (obtenerCambiosHtml) y entonces se guarda
    nuevoHtml(value) {
      this.htmlForEditor = value;
      this.guardar();
    },
    remplaceImagePortada(value) {
      if (value && value.length) this.imagePortada = value[0].imagen;
    },
    imagenesNoticia(value) {
      this.imagenesnoticia = value.map((element) => element.imagen);
    },
    fechaParaApi() {
      // Fecha local a medianoche, igual que antes del rediseño
      const m = String(this.fechaNoticia || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
      return m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date();
    },
    async guardar() {
      const data = {
        id: this.noticia ? this.noticia.id : null,
        titulo: this.tituloNoticia,
        resumenNoticia: this.resumenNoticia || "",
        htmlText: this.htmlForEditor,
        estadoNoticia: this.estadoNoticia,
        fechaPublicacion: this.fechaParaApi(),
        imagenPortada: this.imagePortada,
        imagenesNoticia: this.imagenesnoticia,
        galeria: this.gallerySelected ? this.gallerySelected : 0,
      };
      if (this.esCaritas) data.paginaPrincipal = this.paginaPrincipal ? 1 : 0;

      try {
        const respuesta = await axios.post(this.esCaritas ? "/noticiasCaritas/editarNoticia" : "/noticias/editarNoticia", data);
        avisar(this, `«${this.tituloNoticia}» ${this.estadoNoticia ? "está publicada en la web" : "se ha guardado como borrador"}.`, "success", this.noticia ? "Noticia modificada" : "Noticia creada");
        if (this.avisarMovil && this.estadoNoticia) this.enviarAvisoMovil(respuesta.data && respuesta.data.noticiaId);
        this.$emit("changeNews", true);
        this.closeModal();
      } catch (error) {
        avisarError(this, error, "No se pudo guardar la noticia. Revisa los datos.");
      } finally {
        this.guardando = false;
      }
    },
    // La noticia ya está guardada: si el aviso falla, solo se informa del aviso
    async enviarAvisoMovil(id) {
      const noticiaId = id || (this.noticia && this.noticia.id);
      if (!noticiaId) return;
      const texto = (this.resumenNoticia || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
      try {
        const { data } = await axios.post("/avisos/enviar", {
          titulo: this.tituloNoticia.slice(0, 80),
          cuerpo: (texto || "Nueva noticia en la web de la parroquia.").slice(0, 200),
          url: `/noticia?id=${this.esCaritas ? "caritas-" : ""}${noticiaId}`,
          imagen: this.imagePortada || null,
        });
        avisar(this, data.message, "success", "Aviso al móvil enviado");
      } catch (error) {
        avisarError(this, error, "La noticia se guardó, pero no se pudo enviar el aviso al móvil.");
      }
    },
    saveNews() {
      this.intentado = true;
      if (this.faltan.length) return;
      this.guardando = true;
      // Pide el HTML al editor; al recibirlo (nuevoHtml) se guarda
      this.obtenerCambiosHtml = !this.obtenerCambiosHtml;
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.en-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 24px;
  align-items: start;
}

@media (max-width: 991px) {
  .en-layout {
    grid-template-columns: 1fr;
  }
}

.en-titulo {
  height: 48px;
  font-size: 1.1rem;
  font-weight: 600;
}

.en-side {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.en-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid var(--sd-border);
  border-radius: 14px;
  background: var(--sd-surface-2);
}

.en-box-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--sd-muted);
}

.en-thumbs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}

.en-thumbs img,
.en-thumbs-more {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  object-fit: cover;
}

.en-thumbs-more {
  display: grid;
  place-items: center;
  background: var(--sd-surface);
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--sd-muted);
}

.en-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 0.85rem;
  color: var(--sd-danger);
}
</style>
